import { Page, View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface KeyTopicsPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const KeyTopicsPage = ({ event, footer }: KeyTopicsPageProps) => {
  const { t } = useTranslation();

  const eventKeyTopicsItems = useMemo(
    () =>
      event?.website_content?.keytopics
        ?.filter(e => e.published)
        .sort((a, b) => a.order - b.order)
        ?.map(keyTopic => ({
          title: keyTopic.title,
          subtitle: keyTopic.description,
          order: keyTopic.order,
        })),
    [event?.website_content?.keytopics]
  )?.slice(0, 8);

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.container,
        }}
      >
        <View style={{ padding: 53 }}>
          <Text style={{ ...styles.title }}>
            {t('key-topics-to-talk-about')}
          </Text>

          <View
            style={{
              ...globalStyles.lineBar,
              borderColor: event?.design?.themeColor ?? 'black',
              marginLeft: 0,
              marginBottom: 40,
            }}
          />

          <View style={styles.keyTopicsListWrapper}>
            {eventKeyTopicsItems?.map((keytopicItem, index) => {
              return (
                <View
                  key={index}
                  style={{
                    ...styles.keyTopicsListItemWrapper,
                    border: `4px solid ${event?.design?.themeColor ?? 'black'}`,
                  }}
                >
                  <Text style={styles.keyTopicsTitle}>
                    {keytopicItem?.title}
                  </Text>
                  <Text style={styles.keyTopicsText}>
                    {keytopicItem?.subtitle}
                  </Text>
                </View>
              );
            })}
          </View>
        </View>

        <SafeImage
          src="https://media.we-conect.com/images/pdf/partnerprospectus/keytopics_1.png"
          style={{
            ...styles.image,
          }}
        />
      </View>

      {footer}
    </Page>
  );
};

export default KeyTopicsPage;
